<template>
  <!-- Main wrapper  -->
  <div id="main-wrapper">
    <div class="unix-login">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-8 col-sm-12">
            <div class="register-content card">
              <div class="register-form">
                <h4>Register</h4>
                <div v-if="registerStatus===1">
                  <p>Thank you for signing up! Please check your email, we have sent an approval letter.</p>
                </div>
                <div v-else-if="registerStatus===2">
                  <p>{{errorMessage}}</p>
                </div>
                <form v-else @submit="register">
                  <div class="form-group">
                    <!--<label>First Name</label>-->
                    <input type="text" class="form-control" v-model="user.fname"
                           placeholder="First Name *" required>
                  </div>
                  <div class="form-group">
                    <!--<label>Last Name</label>-->
                    <input type="text" class="form-control" placeholder="Last Name *" required
                           v-model="user.lname">
                  </div>
                  <div class="form-group">
                    <!--<label>Email address</label>-->
                    <input type="email" class="form-control" placeholder="Email *" v-model="user.email"
                           required>
                  </div>
                  <div class="form-group">
                    <!--<label>Telephone</label>-->
                    <div class="input-group">
                      <!--<input type="text" class="form-control" aria-label="Text input with dropdown button">-->
                      <div class="input-group-append">
                        <button class="btn-primary dropdown-toggle" type="button" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                          {{user.tel_country?user.tel_country:'Country'}}
                        </button>
                        <div class="dropdown-menu">
                          <a :key="c.code" v-for="c in $root.$data.countries" class="dropdown-item"
                             href="javascript:void(0)" @click="setCountry(c)">{{c.code}}</a>
                        </div>
                      </div>
                      <input type="tel" class="form-control" placeholder="Telephone (optional)" v-model="user.tel">
                    </div>
                  </div>
                  <div class="form-group">
                    <!--<label>Password</label>-->
                    <input type="password" class="form-control" placeholder="Password ( > 8 mixed chars ) *" required
                           v-model="user.password">
                  </div>
                  <div class="form-group">
                    <!--<label>Password Repeat</label>-->
                    <input type="password" class="form-control" v-model="passwordRepeat" placeholder="Password Repeat *"
                           required>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="checkTerms" required> Agree the <a
                      href="http://dapp.atidium.io/#/terms"
                      target="_blank">terms & conditions</a> and
                      <a
                        href="http://dapp.atidium.io/#/privacy" target="_blank">privacy policy</a>. *
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="user.subscribe"> Please subscribe me to SmartFleet news.
                    </label>
                  </div>
                  <button type="submit" class="btn btn-primary btn-flat m-b-10 m-t-10"
                          :disabled="user.password.length<8  || user.password!==passwordRepeat || !checkTerms">Register
                  </button>
                  <div class="register-link text-center">
                    <p>Already have account ?
                      <router-link to="/login">Login here</router-link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
  export default {
    name: 'Register',
    data() {
      return {
        registerStatus: 0,
        checkTerms: false,
        user: {
          email: null,
          password: '',
          fname: null,
          lname: null,
          wallet_key: [],
          tel_country: null,
          tel: null,
          country: null,
          gender: null,
          birth_year: null,
          subscribe: false,
          gToken: '',
          image: null,
          mode: -2,
        },
        passwordRepeat: '',
        errorMessage: 'There has been a temporary issue. Please try again later.'
      };
    },
    methods: {
      setCountry(country) {
        this.user.country = country.code;
        this.user.tel_country = country.dial_code;
      },
      register(e) {
        e.preventDefault();
        if (!this.user.tel) this.user.tel = null;
        this.axios.post(this.$root.$data.api.user, this.user)
          .then(response => {
            if (response.error) {
              this.registerStatus = 2;
              if (response.error.errmsg) {
                this.errorMessage = response.error.errmsg;
              }
            } else {
              this.registerStatus = 1;
            }
          }, response => {
            this.registerStatus = 2;
          });
      },
    },
    mounted() {
      let self = this;
      grecaptcha.ready(function () {
        grecaptcha.execute('6LcM7X0UAAAAAIDGLwBItz518xeb4cRC5dvuWGTW', { action: 'register' })
          .then(function (token) {
            self.user.gToken = token;
          });
      });

      $('.register-form')
        .find('input,select')
        .blur(function (event) {
          event.target.checkValidity();
        });
    }
  };
</script>
<style scoped>
  .dropdown-menu {
    height: 360px !important;
    overflow-y: auto !important;
    transform: translate3d(-1px, 46px, 0px) !important;
  }

  .dropdown-menu::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  .dropdown-menu::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
  }

  .dropdown-menu::-webkit-scrollbar-thumb {
    background-color: #005cbf;
  }

  .input-group-append {
    z-index: 10;
  }

  input:invalid, select:invalid {
    border-color: rgba(160, 0, 0, 0.5);
  }

  input:valid, select:valid {
    border-color: rgba(0, 160, 0, 0.5);
  }

  button.btn-primary {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Register/Register.vue